import Dexie from 'dexie';

const db = new Dexie('PapaRollPDV');

db.version(1).stores({
    // Catálogos (se vacían y reinsertan en cada sincronización descendente)
    empleados:   '++id, usuario, sucursal',
    productos:   '++id, nombre, tipo',
    metodos:     '++id, nombre, tipo',
    sucursales:  '++id, nombre',
    proveedores: '++id, nombre',
    eventos:     '++id, nombre',

    // Operaciones locales (se limpian después de sincronización ascendente exitosa)
    ventas:            '++id, fecha',
    ventas_productos:  '++id, venta_local_id',
    vueltas:           '++id, fecha',
    vueltas_productos: '++id, vuelta_local_id',
    asistencias:       '++id, fecha',
    revisiones:        '++id, fecha_creacion',
    cortes:            '++id, fecha',
    gastos:            '++id, fecha',

    // Sesión local del empleado autenticado
    sesion: '++id'
});

db.version(2).stores({
    vueltas_pagos: '++id, vuelta_local_id',
});

db.version(3).stores({
    pagos_vueltas: '++id, fecha',
});

db.version(4).stores({
    conos: '++id, fecha',
});

export default db;
